import i18n from "i18n";

export const settingsInputList = () => [
	{ id: 1, name: "showTimer", label: i18n.t("label.showTimer") },
	{
		id: 2,
		name: "allowTickAllPartsTools",
		label: i18n.t("label.allowTickAllPartsToolsInService"),
	},
	{
		id: 3,
		name: "listPartsToolsByStageZone",
		label: i18n.t("label.listPartsByStage"),
	},
	{
		id: 4,
		name: "hideTools",
		label: i18n.t("label.hideToolsInService"),
	},
	{
		id: 5,
		name: "hideParts",
		label: i18n.t("label.hidePartsInService"),
	},
];

export const Questionheaders = (rolePlural) => [
	{ id: 1, name: i18n.t("label.caption"), width: "20vw" },
	{ id: 2, name: i18n.t("label.type"), width: "10vw" },
	{ id: 3, name: i18n.t("label.timing"), width: "20vw" },
	{ id: 4, name: rolePlural, width: "17vw" },
	{ id: 5, name: i18n.t("label.compulsory"), width: "8vw" },
	{ id: 6, name: i18n.t("label.additionalOptions"), width: "30vw" },
];

export const QuestionColumn = [
	{ id: 1, name: "caption", style: { width: "20vw" } },
	{ id: 2, name: "modelType", style: { width: "10vw" } },
	{ id: 3, name: "modelTiming", style: { width: "20vw" } },
	{ id: 4, name: "modelRoles", style: { width: "17vw" } },
	{ id: 5, name: "compulsory", style: { width: "8vw" } },
	{ id: 6, name: "additional", style: { width: "30vw" } },
];

export const ModelZoneTableHeader = (ModelType, customCaptions) => {
	if (ModelType === "F")
		return [
			i18n.t("label.name"),
			i18n.t("label.image"),
			i18n.t("label.defaultEntityFilter", { entity: customCaptions.asset }),
		];
	else return [i18n.t("label.name"), i18n.t("label.image")];
};

export const ModelZoneTableColumn = (ModelType) => {
	if (ModelType === "F")
		return [
			{ id: 1, name: "name", style: { width: "33vw" } },
			{ id: 2, name: "imageURL", style: { width: "33vw" } },
			{ id: 3, name: "defaultSiteAssetFilter", style: { width: "33vw" } },
		];
	else
		return [
			{ id: 1, name: "name", style: { width: "50vw" } },
			{ id: 2, name: "imageURL", style: { width: "50vw" } },
		];
};

export const ModelStageTableHeader = (ModelType, asset, zonePlural) => {
	if (ModelType === "F")
		return [
			i18n.t("label.name"),
			i18n.t("label.image"),
			i18n.t("label.hasEntity", { entity: zonePlural }),
			i18n.t("label.defaultEntityFilter", { entity: asset }),
		];
	else
		return [
			i18n.t("label.name"),
			i18n.t("label.image"),
			i18n.t("label.hasEntity", { entity: zonePlural }),
		];
};

export const ModelStageTableColumn = (ModelType) => {
	if (ModelType === "F")
		return [
			{ id: 1, name: "name", style: { width: "35vw" } },
			{ id: 2, name: "image", style: { width: "35vw" } },
			{ id: 3, name: "hasZones", style: { width: "10vw" } },
			{ id: 4, name: "defaultSiteAssetFilter", style: { width: "20vw" } },
		];
	else
		return [
			{ id: 1, name: "name", style: { width: "40vw" } },
			{ id: 2, name: "image", style: { width: "40vw" } },
			{ id: 3, name: "hasZones", style: { width: "20vw" } },
		];
};

export const ZONES = "zones";
export const QUESTION = "question";
export const QUESTIONPLURAL = "questions";
export const TASK = "task";
export const TASKPLURAL = "tasks";

export const COLLAPSEDID = "collapsedId";
